import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Box } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Marquee from 'react-fast-marquee';
import axios from '../config/axiosConfig';  // Import your axios configuration

const sectorRouteMap = {
    'Basic Materials': '/lists/sector/materials?exchanges=NASDAQ%2CNYSE%2CAMEX',
    'Communication Services': '/lists/sector/communication-services?exchanges=NASDAQ%2CNYSE%2CAMEX',
    'Consumer Cyclical': '/lists/sector/consumer-discretionary?exchanges=NASDAQ%2CNYSE%2CAMEX',
    'Consumer Defensive': '/lists/sector/consumer-staples?exchanges=NASDAQ%2CNYSE%2CAMEX',
    'Energy': '/lists/sector/energy?exchanges=NASDAQ%2CNYSE%2CAMEX',
    'Financial Services': '/lists/sector/financial-services?exchanges=NASDAQ%2CNYSE%2CAMEX',
    'Healthcare': '/lists/sector/healthcare?exchanges=NASDAQ%2CNYSE%2CAMEX',
    'Industrials': '/lists/sector/industrials?exchanges=NASDAQ%2CNYSE%2CAMEX',
    'Real Estate': '/lists/sector/real-estate?exchanges=NASDAQ%2CNYSE%2CAMEX',
    'Technology': '/lists/sector/technology?exchanges=NASDAQ%2CNYSE%2CAMEX',
    'Utilities': '/lists/sector/utilities?exchanges=NASDAQ%2CNYSE%2CAMEX',
};

const SectorGrid = () => {
    const [data, setData] = useState([]);

    const fetchData = async () => {
        try {
            const response = await axios.get('/api/sectorPerformance');  // Adjust the endpoint if needed
            setData(response.data.data);
        } catch (error) {
            console.error('Error fetching sector data:', error);
        }
    };

    useEffect(() => {
        fetchData();  // Initial data fetch

        const intervalId = setInterval(() => {
            fetchData();  // Fetch data every 5 minutes
        }, 5 * 60 * 1000);  // 5 minutes in milliseconds

        return () => clearInterval(intervalId);  // Clean up interval on component unmount
    }, []);

    return (
        <Box
            sx={{
                display: 'flex',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
            }}
        >
            <Marquee
                velocity={10}  // Adjust the speed of scrolling
                direction="left"  // Specify the direction
                resetAfterTries={200}  // Optional: to reset after long duration
            >
                {data.map((item, index) => {
                    const isPositive = parseFloat(item.changesPercentage) > 0;
                    return (
                        <Box
                            key={index}
                            component={RouterLink}
                            to={sectorRouteMap[item.sector] || '#'}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                marginRight: 2,
                                whiteSpace: 'nowrap',
                                textDecoration: 'none',
                                color: 'inherit',
                                cursor: 'pointer',
                            }}
                        >
                            <Typography variant="body1" sx={{ marginRight: 1 }}>
                                {item.sector}{' '}
                                <Typography
                                    component="span"
                                    variant="body1"
                                    sx={{ color: isPositive ? 'green' : 'red' }}
                                >
                                    {item.changesPercentage}
                                </Typography>
                            </Typography>
                            {isPositive ? (
                                <ArrowUpwardIcon style={{ color: 'green' }} />
                            ) : (
                                <ArrowDownwardIcon style={{ color: 'red' }} />
                            )}
                            <Typography variant="body1" sx={{ marginLeft: 2 }}>|</Typography> {/* Separator */}
                        </Box>
                    );
                })}
            </Marquee>
        </Box>
    );
};

export default SectorGrid;
